import React from 'react'
import './Nav.css'

function Nav() {
  return (
    <nav class="navbar ">
  <div class="container-fluid">
    <span class="navbar-brand mb-0 h1 text-white">Budget Assist</span>
  </div>
</nav>
  )
}

export default Nav